export const namespace = 'ui-search-reviews';
export const REVIEW_MAX_STARS = 5;
export const MAX_DECIMAL_TO_FLOOR_ROUND = 0.7;
export const MIN_DECIMAL_TO_CEIL_ROUND = 0.3;
